export default {
    templateUrl: 'js/itemcode.component.html',
    bindings: {
        row: '<',
        onOpen: '&',
    },
};
